module.exports = __webpack_public_path__ + "static/media/2011 Moscow, Russia.fb5e0888.jpg";